import { createSlice } from '@reduxjs/toolkit';

export const prohlizeniSestavSlice = createSlice({
    name: 'prohlizeniSestav',
    initialState: {
        data: [],
        loading: true,
    },
    reducers: {
        prohlizeniSestav: (state, action) => {
            console.log("data + loading: false")
            state.data = action.payload
            state.loading = false
        },
        loadingProhlizeniSestav: (state) => {
            console.log("loading: true")
            state.loading = true
        }
    },
});

export const { prohlizeniSestav, loadingProhlizeniSestav } = prohlizeniSestavSlice.actions;

export const prohlizeniSestavData = state => state.prohlizeniSestavdata;


export default prohlizeniSestavSlice.reducer;
